import { ResultsParser } from '@multiversx/sdk-core/out';
import {
  ApiNetworkProvider,
  ProxyNetworkProvider
} from '@multiversx/sdk-network-providers/out';
import { apiAddress, gatewayAddress } from 'config';

export const resultsParser = new ResultsParser();
export const proxyNetworkProvider = new ProxyNetworkProvider(gatewayAddress);
export const apiNetworkProvider = new ApiNetworkProvider(apiAddress);

export * from './rawVesta';
